import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const logLoader: LoaderFunction = async (args) => {
  if (args.params.id === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  const result = await axiosApi.get("/api/systemLogs/" + args.params.id);
  return result.data;
};
